import React from 'react';
import logo from '../assets/images/logo.png';
import './Products.css';

const columnData = [
  {
    title: 'Printing Devices & Supplies',
    image: require('../assets/images/printing-devices.jpeg'),
    list: [
      'Ink Jet Printer',
      'Printing',
      'Colour Laser Printers',
      'Mono Laser Printers',
      'A3 Laser Printers',
      'Inkjet & Photo Printers',
      'Colour Multifunction Laser Printers',
      'Mono Multifunction Laser Printers',
      'Colour Multifunction Deskjet Printers',
      'Mono Multifunction Deskjet Printers',
      'Laser Toner Cartridge',
      'Inkjet Cartridge',
      'Ink Bottles',
      'Paper',
      'Printer Cables',
      'Image Drums',
      'Maintenance Kits',
      'Transfer Kits',
      'Fuzer Kits',
    ],
  },
  {
    title: 'Compatible Toner Cartridges',
      image: require('../assets/images/cartridge1.jpeg'),
    list: [
      'Compatible with HP',
      'Compatible with Canon',
      'Compatible with Samsung',
      'Compatible with Brother',
      'Compatible with Lexmark',
      'Compatible with Sharp',
      'Compatible with Xerox',
      'Compatible with Kyocera',
    ],
  },
  {
    title: 'Computing Devices & Workstations',
    image: require('../assets/images/computing.webp'),
    list: [
      'Desktop',
      'PCs iMac',
      'All-in-One PCs',
      'Laptops & Netbooks',
      'Macbooks',
      'Ultrabook',
      'Tablets',
      'Smartphones',
      'Servers',
      'Workstations',
      'Industrial PCs',
    ],
  },
  {
    title: 'Computer Components',
    image: require('../assets/images/computercomponents.jpeg'),
    list: [
      'Computers',
      'Components',
      'Sound Cards',
      'Graphic Cards',
      'Card Readers',
      'TV & Video Cards',
      'AMD Processors',
      'Intel Processors',
      'Core i3 Processors',
      'Core i5 Processors',
      'Core i7 Processors',
      '128 GB, 64GB, 32GB, 16GB, 8GB & 4GB Memory',
      '2GB Memory',
      'DDR 1-5',
    ],
  },
  {
    title: 'Storage Solutions',
    image: require('../assets/images/storagesolutions.jpeg'),
    list: [
      'Hard Disk',
      'Storage',
      'Tower Server',
      'Rack Server',
      'Blade Servers',
      'Server Parts & Accessories',
      'Internal Hard Drives',
      'External Hard Drives',
      'Internal SSD',
      'External SSD',
      'NAS',
      'LTO Tapes',
      'USB Flash Drives',
      'Memory Cards',
      'DVD Media',
      'CD Media',
    ],
  },
  {
    title: 'Input & Output Devices',
    image: require('../assets/images/input-output.jpeg'),
    list: [
      'Keyboards',
      'Mice',
      'Docking Stations Tablets',
    ],
  },
  {
    title: 'Peripherals & Communication',
    image: require('../assets/images/peripherals-communication.jpeg'),
    list: [
      'Headphones',
      'Peripherals & Communication',
      'Shredders & Laminators',
      'Scanners',
      'Webcams',
      'Bar Code & Label Printers',
      'Monitor Stand & Ribbons',
      'Barcode Scanners',
      'Printer Accessories',
      'Labels',
      'Media',
      'Batteries',
      'Video/ Voice Conferencing',
      'Speakers & Headphones',
      'Headsets and Telephone Accessories',
    ],
  },
  {
    title: 'Networking Equipment',
    image: require('../assets/images/networkingequipment.jpeg'),
    list: [
      'Server',
      'Networking',
      'KVM Switches',
      'Network Switches',
      'Routers & Bridges',
      'Wireless Networking',
      'Network Cables',
      'Modems',
      'Network Security & Firewall',
      'IP Cameras',
      'Racking Cabinets',
      'Network Adapters',
      'Print Servers',
      'UPS',
    ],
  },
  {
    title: 'Power, Memory & Accessories',
    image: require('../assets/images/Power-Memory-Accessories.jpeg'),
    list: [
      'Filters & Protection',
      'Power Adaptors',
      'Computer Memory',
      'Laptop Batteries & Adapters',
    ],
  },
  {
    title: 'Software Solutions',
    image: require('../assets/images/softwaresolutions.jpeg'),
    list: [
      'Image by Windows',
      'Softwares',
      'Microsoft Office Solutions',
      'Adobe Photoshop',
      'Adobe Lightroom',
      'Adobe Illustrator',
      'Windows Versions',
      'Mind Manager',
      'Burp Suite',
      'Citrus',
      'Google Suite',
      'Escan',
      'Mcafee',
      'Bit Defender',
    ],
  },
  {
    title: 'TV, Audio & Visual Systems',
    image: require('../assets/images/TV-Audio-Visual-Systems.jpeg'),
    list: [
      'Home Theater System',
      'TV, Sound & Vision',
      'LCDs & Led TVs',
      'LFDs',
      'Speakers & Headphones',
      'Gaming Consoles',
      'AV Cables',
    ],
  },
  {
    title: 'Cameras & Projection',
    image: require('../assets/images/Cameras-Projection.jpeg'),
    list: [
      'Digital Cameras',
      'Digital Camcorders',
      'Digital SLR',
      'Cameras',
      'Camera Accessories',
      'Projectors',
      'Interactive Signages',
      'Whiteboards',
      'Projector Lamps',
      'Whiteboard Accessories',
    ],
  },
];

const Products = () => {
  return (
    <div className="products-page">
      <section className="hero-section">
        <div className="home-container">
          <div className="home-content">
            <div className="logo-section">
              <div className="logo">
                <img src={logo} alt="Image Technology Logo" className="logo-image" />
              </div>
            </div>
            <div className="text-section">
              <h2>Our Products</h2>
              <p>
                Discover a powerful range of imaging solutions tailored for modern businesses. From advanced toner cartridges to high-performance imaging tools, our products combine innovation, efficiency, and reliability to keep you moving forward.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="products-columns-container products-columns-12">
        {columnData.map((col, idx) => (
          <div className="products-column" key={idx}>
            <div className="products-square-image">
              <img src={col.image} alt={col.title} loading="lazy" />
            </div>
            <h2 className="products-column-title">{col.title}</h2>
            <ul className="products-list">
              {col.list.map((item, i) => (
                <li key={i}>{item}</li>
          ))}
            </ul>
        </div>
        ))}
      </div>
    </div>
  );
};

export default Products; 